import { getKudosDetailsByUniqId } from "../../../services/apis";
import Claim from "../../../views/Claim/Claim";

export async function getServerSideProps({ params }: any) {
  try {
    const details = await getKudosDetailsByUniqId(params.nftId);
    return { props: { details } };
  } catch (error) {
    return { props: { details: null } };
  }
}

const ClaimPage = ({ details }: any) => {
  return <Claim details={details} />;
};

export default ClaimPage;
